// 亚冬会 customViewType:'GP'|'GC'；GP代表总的父赛程赛果；GC代表子赛程赛果；可以放到scheduleInfo里面
export default {
  data() {
    return {
      bigSportsList: [
        {
          id: 'ALP',
          CN: '高山滑雪',
          EN: '',
          routePageArr: [
            {
              //
              eventIdArr: [
                'ALPMTC----------------------------',
                'ALPWTC----------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '个人成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'BOB',
          CN: '雪车',
          EN: '',
          routePageArr: [
            {
              // 团体成绩
              eventIdArr: [
                'BOBMTEAM2-------------------------',
                'BOBWTEAM2-------------------------',
                'BOBMTEAM4-------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'teamResult',
                  name: '综合成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_teamResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '个人成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
            D: [
              {
                startList: 'mode_3',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_3',
                teamResult: 'mode_3',
                combinedResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'BTH',
          CN: '冬季两项',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'CCS',
          CN: '越野滑雪',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'CUR',
          CN: '冰壶',
          EN: '',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
            D: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'FRS',
          CN: '自由式滑雪',
          EN: '',
          routePageArr: [
            {
              customViewType: 'GP',
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '小组成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              phaseIdArr: [
                // 障碍追逐
                'FRSMSX----------------FNL---------',
                'FRSWSX----------------FNL---------',
                'FRSMSX----------------QUAL--------',
                'FRSWSX----------------QUAL--------',

                // 雪上技巧
                'FRSMDM----------------FNL---------',
                'FRSWDM----------------FNL---------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                customViewType: 'GP',
                startList: 'mode_16',
                groupResult: 'mode_16',
              },
              {
                startList: 'mode_3',
                localData: 'mode_10',
                compreResult: 'mode_3',
              },
            ],
            T: [
              {
                customViewType: 'GP',
                startList: 'mode_15',
                groupResult: 'mode_15',
              },
              {
                startList: 'mode_10',
                localData: 'mode_10',
                groupResult: 'mode_15',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
                groupResult: 'mode_16',
              },
            ],
          },
        },
        {
          id: 'FSK',
          CN: '花样滑冰',
          EN: '',
          routePageArr: [
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '个人成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
            D: [
              {
                startList: 'mode_14',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'IHO',
          CN: '冰球',
          EN: '',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'LUG',
          CN: '雪橇',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
            D: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'NCB',
          CN: '北欧两项',
          EN: '',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'SBD',
          CN: '单板滑雪',
          EN: '',
          routePageArr: [
            {
              customViewType: 'GP',
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '小组成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 决赛单独配置
              phaseIdArr: [
                'SBDMSBX---------------FNL---------',
                'SBDMPGS---------------FNL---------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'teamResult',
                  name: '综合成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_teamResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                customViewType: 'GP',
                startList: 'mode_16',
                localData: 'mode_3',
                groupResult: 'mode_16',
              },
              {
                eventIdArr: [
                  'SBDWSBX---------------------------',
                  'SBDWPGS---------------------------',
                ],
                startList: 'mode_3',
                localData: 'mode_3',
              },
              {
                startList: 'mode_3',
                localData: 'mode_10',
                teamResult: 'mode_3',
              },
            ],
            T: [
              {
                customViewType: 'GP',
                startList: 'mode_15',
                groupResult: 'mode_15',
              },
              {
                startList: 'mode_10',
                localData: 'mode_10',
                groupResult: 'mode_15',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
                groupResult: 'mode_16',
              },
            ],
          },
        },
        {
          id: 'SJP',
          CN: '跳台滑雪',
          EN: '',
          routePageArr: [
            {
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'SKN',
          CN: '钢架雪车',
          EN: '',
          routePageArr: [
            {
              // 团体成绩
              eventIdArr: ['SKNXRELAY2------------------------'],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'teamResult',
                  name: '综合成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_teamResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '个人成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
            D: [
              {
                startList: 'mode_3',
                singleResult: 'mode_3',
                compreResult: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_3',
                teamResult: 'mode_3',
                combinedResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'SMT',
          CN: '滑雪登山',
          EN: '',
          routePageArr: [
            {
              // 团体成绩
              customViewType: 'GP',
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '小组成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                customViewType: 'GP',
                startList: 'mode_16',
                groupResult: 'mode_15',
                localData: 'mode_9',
              },
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'BTH',
          CN: '冬季两项',
          EN: '',
          routePageArr: [
            {
              // 所有单人的项目都是这样，所以拿标题文字区分
              // localDataTitleArr: ['分组预赛', '复活赛', '1/4决赛'],
              customViewType: 'GP',
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '小组成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                customViewType: 'GP',
                startList: 'mode_16',
                localData: 'mode_9',
                groupResult: 'mode_15',
              },
              {
                startList: 'mode_3',
                localData: 'mode_9',
                groupResult: 'mode_15',
              },
            ],
            T: [
              {
                customViewType: 'GP',
                startList: 'mode_15',
                localData: 'mode_9',
                groupResult: 'mode_15',
              },
              {
                startList: 'mode_10',
                localData: 'mode_10',
                groupResult: 'mode_15',
              },
            ],
          },
          combat: {
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_9',
              },
            ],
          },
        },
        {
          id: 'STK',
          CN: '短道速滑',
          EN: '',
          routePageArr: [
            {
              // 团体成绩
              customViewType: 'GP',
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '小组成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                customViewType: 'GP',
                startList: 'mode_16',
                groupResult: 'mode_15',
              },
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                customViewType: 'GP',
                startList: 'mode_16',
                groupResult: 'mode_15',
              },
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
          },
          combat: {
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_9',
              },
            ],
          },
        },
        {
          id: 'SSK',
          CN: '速度滑冰',
          EN: '',
          routePageArr: [
            {
              // 团体成绩
              customViewType: 'GP',
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '小组成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
                {
                  key: 'dataBattleReport',
                  name: '数据战报',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                customViewType: 'GP',
                startList: 'mode_16',
                groupResult: 'mode_15',
              },
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                customViewType: 'GP',
                startList: 'mode_16',
                groupResult: 'mode_15',
              },
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
          },
          combat: {
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_9',
              },
            ],
          },
        },
      ],
    }
  },
}
